import i18n from 'i18n-js'
import en from './locale/en.json'
import { tx, t } from '@transifex/native'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/es-us'

const localeKey = '@locale'

tx.init({
  token: '1/b2b939d04ce2111ef6aa80dc5c28ab9f40b99ce1',
})

i18n.fallbacks = true

i18n.translations = {
  en,
}

const updateDayjsLocale = locale => {
  const dayjsLocale = locale === 'es_US' ? 'es-us' : 'en'
  dayjs.locale(dayjsLocale)
}

const updateLocaleStrings = async locale => {
  window.embedded_svc.settings.language = locale
  window.embedded_svc.settings.defaultMinimizedText = $t('chat.chat')
  window.embedded_svc.settings.offlineSupportMinimizedText =
    $t('chat.offlineChat')
  window.embedded_svc.settings.loadingText = $t('chat.loading')
}

export const setLocale = async locale => {
  // Set the language code
  await tx.setCurrentLocale(locale)
  await updateLocaleStrings(locale)

  // Set the layout direction to RTL if the language is Arabic or Hebrew
  localStorage.setItem(localeKey, locale)

  updateDayjsLocale(locale)

  return locale
}

export const $t = (key, params = {}) => {
  const defaults = params?.defaults || i18n.t(key)
  return t(i18n.t(key, { defaults }), params)
}

export const getLocale = () => {
  const locale = localStorage.getItem(localeKey)
  if (locale === undefined) return 'en'
  else {
    return locale
  }
}

export default $t
